<template>
  <div class="acts-groups">
    <div
      class="acts-group"
      v-for="status in actStatuses"
      :key="status.id"
      @dragover="dragOver"
      @drop="dropAct($event, status.id)"
    >
      <div class="acts-group-header ms-text">
        <b>{{ status.name }}</b>
      </div>
      <div class="acts-group-container">
        <template v-if="getActs(status.name).length">
          <acts-group-item
            v-for="act in getActs(status.name)"
            :key="act.id"
            :act="act"
            @open-act="openAct"
          />
        </template>
        <div v-else class="ms-nodata ms-help">Акты отсутствуют</div>
      </div>
    </div>
  </div>
</template>

<script>
import ActsGroupItem from './acts-group-item'

export default {
  props: ['acts', 'act-statuses'],
  components: {
    ActsGroupItem
  },
  methods: {
    getActs (statusName) {
      return this.acts.filter(act => act.act_status === statusName)
    },
    openAct (payload) {
      this.$emit('open-act', payload)
    },
    dragOver (e) {
      e.preventDefault()
    },
    dropAct (e, newStatusId) {
      const act = JSON.parse(e.dataTransfer.getData('act'))
      const { id, act_status_id } = act
      if (act_status_id === newStatusId) return
      this.$emit('change-act-status', { id, act_status_id: newStatusId })
    }
  }
}
</script>

<style lang="less">
.acts-groups {
  display: flex;
}
.acts-group {
  flex: 1;
  padding: 0 8px;
  padding-bottom: 8px;
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid #e8eaec;
  border-radius: 4px;

  &:not(:first-child) {
    margin-left: 16px;
  }

  &-header {
    padding: 8px 0;
    font-size: 14px;
  }
}
.dark {
  .acts-group {
    background: rgba(@dt-dark-primary, 0.4);
    border-color: rgba(@dt-dark-primary, 0.6);
  }
}
</style>
